import React, { Component } from 'react'
import '../App.css';
export class courseNav extends Component {
  render() {
    return (
      <div className="nav">C R U D</div>
    )
  }
}

export default courseNav